import React from "react";
import './component.css'
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";

import { useNavigate } from "react-router-dom";
import CohortNameComponent from "./CohortNameComp/component";
import CohortTypeComponent from "./CohortCreationType/component";
import CohortAreaNameComponent from "./CohortAreaNameComp/component";
import CohortUserSelect from "./CohortSelectUserComp/component";
import CohortVMSelect from "./CohortSelectVMComp/component";
import CohortSuccessComponent from "./CohortSuccessMsg/component";

const CohortCreationComponent = (props) => {
  const steps = [
    "Cohort Name",
    "Cohort Type",
    "Area Name",
    "Select User",
    "Select Vending Machine"
  ];

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

 

  return (
    <div className="main-div">
      <Sidebar />

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create Cohort
          </h2>
        </div>
        <div style={{ marginLeft: "20px", width: "78vw" }}>
          <div style={{ width: "40vw", margin: "30px" }}>
            <Box sx={{ width: "60vw" }}>
              <Stepper activeStep={props.activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Box>
          </div>
          {props.isCohortCreated ? (
            <CohortSuccessComponent cohortId={props.cohortId} />
          ) : (
            <div>
              <React.Fragment>
                {props.activeStep === 0 ? (
                  <CohortNameComponent
                    errors={props.errors}
                    cohortName={props.cohortName}
                    handleCohortNameChange={props.handleCohortNameChange}
                  />
                ) : props.activeStep === 1 ? (
                  <CohortTypeComponent
                    errors={props.errors}
                    seedData={props.seedData}
                    cohortType={props.cohortType}
                    handleCohortTypeChange={props.handleCohortTypeChange}
                  />
                ) : props.activeStep === 2 ? (
                  <CohortAreaNameComponent
                    errors={props.errors}
                    seedData={props.seedData}
                    cohortAreaName={props.cohortAreaName}
                    handleCohortAreaNameChange={props.handleCohortAreaNameChange}
                  />
                ) : props.activeStep === 3 ? (
                  <CohortUserSelect
                    errors={props.errors}
                    seedData={props.seedData}
                    cohortSelectUser={props.cohortSelectUser}
                    handleCohortSelectUserChange={props.handleCohortSelectUserChange}
                  />
                ) : (
                  <CohortVMSelect
                    errors={props.errors}
                    seedData={props.seedData}
                    cohortSelectVM={props.cohortSelectVM}
                    handleCohortSelectVMChange={props.handleCohortSelectVMChange}
                  />
                )}
              </React.Fragment>
            </div>
          )}

          {!props.isCohortCreated && (
            <Box className="cohortCreationBtn">
            <Button
              className="backbtnaddpage1"
              // disabled={props.activeStep === 0}
              onClick={props.handleClose}
            >
              Back
            </Button>
          
            {props.activeStep === steps.length - 1 ? ( 
              <Button
                className="saveandcontinue"
                onClick={props.handleCreateNewCohort}
              >
                Submit
              </Button>
            ) : (
              <Button className="saveandcontinue" onClick={props.handleNext}>
                Save and Continue
              </Button>
            )}
          </Box>
          
          )}
        </div>
      </div>
    </div>
  );
};

export default CohortCreationComponent;
